import "./CarrinhoItemMobile.css";

export default function CarrinhoItemMobile({
  produto,

  saldo,

  quantidade,

  mensagem,
  tipoMensagem,

  precoUnitario,
  subtotal,

  caixa,
  pesoPorPeca,

  pesoCaixa,
  pesoPeca,

  diminuir,
  aumentar,
  alterarQuantidade,
  remover,
}) {

  return (

    <article className="carrinhoItemMobile-card">

      {/* Produto */}

      <div className="carrinhoItemMobile-produto">

        <div className="carrinhoItemMobile-foto">

          {produto.foto ? (

            <img
              src={produto.foto}
              alt={produto.descricao}
            />

          ) : (

            <div className="carrinhoItemMobile-semFoto">
              Sem imagem
            </div>

          )}

        </div>

        <div className="carrinhoItemMobile-info">

          <h3>

            {produto.descricao.length > 50
              ? `${produto.descricao
                  .slice(0,50)
                  .trim()
                  .replace(/\s+\S*$/, "")}...`
              : produto.descricao}

          </h3>

          <div className="carrinhoItemMobile-pesos">

            {pesoCaixa > 0 && (

              <span>
                CX: {pesoCaixa.toLocaleString("pt-BR")} kg
              </span>

            )}

            {pesoCaixa > 0 &&
              pesoPeca > 0 && (
                <span> • </span>
            )}

            {pesoPeca > 0 && (

              <span>
                Unid.: {pesoPeca.toLocaleString("pt-BR")} kg
              </span>

            )}

            {pesoCaixa === 0 &&
              pesoPeca === 0 && (

                <span>

                  Peso{" "}
                  {Number(produto.pesol).toLocaleString("pt-BR")} kg

                </span>

            )}

          </div>

          {Number(produto.corrigepreco) === 1 && (

            <div className="carrinhoItemMobile-pesoVariavel">
              PRODUTO COM PESO VARIÁVEL
            </div>

          )}

        </div>

      </div>

      {/* Coluna direita */}

      <div className="carrinhoItemMobile-direita">

        <div className="carrinhoItemMobile-preco">

          <strong>

            R$

            {" "}

            {precoUnitario.toLocaleString("pt-BR",{
              minimumFractionDigits:2,
              maximumFractionDigits:2
            })}

          </strong>

          {(caixa || pesoPorPeca) && (

            <span>

              /kg

            </span>

          )}

        </div>

        {caixa && (

          <div className="carrinhoItemMobile-medida">

            {quantidade}

            {" "}

            {quantidade === 1
              ? "caixa"
              : "caixas"}

            {" × "}

            {pesoCaixa}

            {" kg"}

          </div>

        )}

        {pesoPorPeca && (

          <div className="carrinhoItemMobile-medida">

            {quantidade}

            {" "}

            {quantidade === 1
              ? "peça"
              : "peças"}

            {" × "}

            {pesoPeca}

            {" kg"}

          </div>

        )}

        <div className="carrinhoItemMobile-controle">

          <button

            onClick={diminuir}

            disabled={saldo<=0}

          >

            -

          </button>

          <input

            type="number"

            min={1}

            max={saldo}

            value={quantidade}

            disabled={saldo<=0}

            onChange={(e)=>

              alterarQuantidade(e.target.value)

            }

          />

          <button

            onClick={aumentar}

            disabled={saldo<=0}

          >

            +

          </button>

        </div>

        <div
          className={`carrinhoItemMobile-mensagem ${tipoMensagem}`}
        >

          {saldo<=0
            ? "Produto indisponível."
            : mensagem}

        </div>

        <div className="carrinhoItemMobile-rodape">

          <strong className="carrinhoItemMobile-total">

            R$

            {" "}

            {subtotal.toLocaleString("pt-BR",{

              minimumFractionDigits:2,
              maximumFractionDigits:2

            })}

          </strong>

          <button

            className="carrinhoItemMobile-remover"

            onClick={remover}

            title="Remover"

          >

            ✕

          </button>

        </div>

      </div>

    </article>

  );

}